import React from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getEmployeeCategories } from '../redux.actions';

const SelectEmployeeCategory = ({
    getEmployeeCategories,
    input: { value, onChange }
}) => {
    const [employeeCategories, setEmployeeCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getEmployeeCategories({
            handleSubmit: (data) => {
                setIsLoading(false);
                if (data && data.data) {
                    setEmployeeCategories(
                        data.data.map((category) => ({
                            name: category.name,
                            value: category.name
                        }))
                    );
                }
            }
        });
    }, [getEmployeeCategories]);

    const selectedCategory =
        employeeCategories.find((c) => String(c.value) === String(value)) || null;

    return (
        <Autocomplete
            size='small'
            sx={{
                minWidth: 158,
                backgroundColor: theme => theme.palette.common.paper
            }}
            componentsProps={{
                paper: {
                    sx: {
                        '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                        }
                    }
                }
            }}
            options={employeeCategories}
            getOptionLabel={(option) => option.name || ''}
            value={selectedCategory}
            onChange={(event, newValue) => {
                onChange(newValue ? newValue.value : '');
            }}
            loading={isLoading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Category'
                    placeholder='Select category'
                    sx={{
                        '& .MuiInputBase-input': { fontSize: '12px' },
                        '& .MuiInputLabel-root': { fontSize: '12px' }
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        color='inherit'
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};

const mapDispatchToProps = (dispatch) => ({
    getEmployeeCategories: (payload) => dispatch(getEmployeeCategories(payload))
});

export default connect(null, mapDispatchToProps)(SelectEmployeeCategory);
